<div class="app-shell">
  <aside class="sidebar">
    <div class="logo">I</div>

    <nav class="primary-nav" aria-label="Portfolio navigation">
      <button *ngFor="let item of navItems" class="nav-item" [class.active]="item.active">
        <span class="nav-icon">{{ item.icon }}</span>
        <span>{{ item.label }}</span>
      </button>
    </nav>

    <div class="sidebar-footer">
      <button *ngFor="let item of footerItems" class="footer-link">
        <span>{{ item.icon }}</span>
        <span>{{ item.label }}</span>
      </button>
    </div>
  </aside>

  <main class="page">
    <header class="page-header">
      <div>
        <h1>Welcome, Brian!</h1>
        <div class="header-controls">
          <button class="select-button">♙ {{ selectedClient }}⌄</button>
          <button class="date-button">◴ Jan 1, 2026 - Dec 31, 2026</button>
          <div class="range-tabs">
            <button *ngFor="let range of ranges" [class.active]="range === activeRange">
              {{ range }}
            </button>
          </div>
        </div>
      </div>
    </header>

    <section class="kpi-strip" aria-label="Portfolio summary">
      <article *ngFor="let kpi of kpis" class="kpi-card" [class.large]="kpi.label === 'NAV'">
        <span class="kpi-label">{{ kpi.label }}</span>
        <div class="kpi-content">
          <strong>{{ kpi.value }}</strong>
          <svg *ngIf="kpi.sparkline" viewBox="0 0 208 70" preserveAspectRatio="none" aria-hidden="true">
            <polyline [attr.points]="kpi.sparkline" />
          </svg>
        </div>
      </article>
    </section>

    <section class="chart-card">
      <div class="card-title-row">
        <h2>Return &amp; NAV</h2>
        <div class="card-actions">
          <button>▣</button>
          <button>⌁</button>
        </div>
      </div>

      <div class="chart-frame">
        <div class="chart-y-label">Return &amp; NAV</div>
        <div class="axis-pill">10.51 %</div>
        <svg class="main-chart" viewBox="0 0 1352 390" preserveAspectRatio="none" aria-label="Return and NAV line chart">
          <defs>
            <linearGradient id="areaFill" x1="0" x2="0" y1="0" y2="1">
              <stop offset="0%" stop-color="#2aaee4" stop-opacity="0.12" />
              <stop offset="100%" stop-color="#2aaee4" stop-opacity="0" />
            </linearGradient>
          </defs>

          <g class="grid-lines">
            <line x1="0" y1="360" x2="1352" y2="360"></line>
            <line x1="0" y1="285" x2="1352" y2="285"></line>
            <line x1="0" y1="210" x2="1352" y2="210"></line>
            <line x1="0" y1="135" x2="1352" y2="135"></line>
            <line x1="0" y1="60" x2="1352" y2="60"></line>
            <line x1="220" y1="0" x2="220" y2="365"></line>
            <line x1="440" y1="0" x2="440" y2="365"></line>
            <line x1="670" y1="0" x2="670" y2="365"></line>
            <line x1="900" y1="0" x2="900" y2="365"></line>
            <line x1="1120" y1="0" x2="1120" y2="365"></line>
          </g>

          <polygon class="chart-area" [attr.points]="chartArea"></polygon>
          <polyline class="chart-line" [attr.points]="chartLine"></polyline>
        </svg>

        <div class="y-axis-values">
          <span>9.00 %</span>
          <span>6.00 %</span>
          <span>3.00 %</span>
          <span>0.00 %</span>
        </div>

        <div class="x-axis-values">
          <span>29 Feb</span>
          <span>30 Apr</span>
          <span>30 Jun</span>
          <span>31 Aug</span>
          <span>31 Oct</span>
          <span>30 Dec</span>
        </div>
      </div>
    </section>

    <section class="exposure-grid" aria-label="Portfolio exposure">
      <article class="exposure-card">
        <h3>Currency exposure</h3>
        <div *ngFor="let item of currencyExposure" class="exposure-row">
          <span class="donut" [ngClass]="item.colorClass"></span>
          <span class="exposure-label">{{ item.label }}</span>
          <strong>{{ item.value | number:'1.2-2' }} %</strong>
        </div>
      </article>

      <article class="exposure-card">
        <h3>Country exposure</h3>
        <div *ngFor="let item of countryExposure" class="exposure-row">
          <span class="donut" [ngClass]="item.colorClass"></span>
          <span class="exposure-label">{{ item.label }}</span>
          <strong>{{ item.value | number:'1.2-2' }} %</strong>
        </div>
      </article>

      <article class="exposure-card">
        <h3>Sector exposure</h3>
        <div *ngFor="let item of sectorExposure" class="exposure-row">
          <span class="donut" [ngClass]="item.colorClass"></span>
          <span class="exposure-label">{{ item.label }}</span>
          <strong>{{ item.value | number:'1.2-2' }} %</strong>
        </div>
      </article>
    </section>

    <section class="holdings-card">
      <table>
        <thead>
          <tr>
            <th>Name ⇅</th>
            <th>NAV 1/1/2026 ⇅</th>
            <th>External flow ⇅</th>
            <th>Total performance<br /><small>Development ⇅</small></th>
            <th>NAV 12/31/2026 ⇅</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of filteredHoldings">
            <td>
              <div class="holding-name">
                <span class="holding-icon">◈</span>
                <div>
                  <strong>{{ row.name }}</strong>
                  <span *ngIf="row.badge" class="badge">{{ row.badge }}</span>
                </div>
              </div>
            </td>
            <td>{{ row.navStart }}<br /><small>-</small></td>
            <td>{{ row.externalFlow }}</td>
            <td>
              <strong [class]="row.performanceType">{{ row.performance }}</strong>
              <svg *ngIf="row.sparkline" class="table-spark" viewBox="0 0 120 32" preserveAspectRatio="none">
                <polyline [attr.points]="tableSparkline"></polyline>
              </svg>
            </td>
            <td>
              {{ row.navEnd }}
              <div class="allocation">
                <span>{{ row.allocation }}</span>
                <span class="mini-donut"></span>
              </div>
            </td>
            <td class="go-cell">→</td>
          </tr>
        </tbody>
      </table>
    </section>
  </main>

  <aside class="right-panel">
    <div class="right-search-row">
      <button class="filter-icon">⌯</button>
      <label class="global-search">
        <span>⌕</span>
        <input [(ngModel)]="searchTerm" placeholder="Search WKN, ISIN, Name" />
      </label>
    </div>

    <section class="side-card">
      <div class="side-title-row">
        <h3>Instrument classification</h3>
        <button>▣</button>
        <button>⌁</button>
      </div>

      <div *ngFor="let item of classification" class="bar-row">
        <div class="bar-label">
          <strong>{{ item.label }}</strong>
          <span>{{ item.value | number:'1.2-2' }} %</span>
        </div>
        <div class="bar-track">
          <span [ngClass]="item.colorClass" [style.width.%]="item.value"></span>
        </div>
      </div>
    </section>

    <section class="side-card">
      <div class="side-title-row">
        <h3>Instrument currency</h3>
        <button>▣</button>
        <button>⌁</button>
      </div>

      <div *ngFor="let item of currencyBreakdown" class="bar-row">
        <div class="bar-label">
          <strong>{{ item.label }}</strong>
          <span>{{ item.value | number:'1.2-2' }} %</span>
        </div>
        <div class="bar-track">
          <span [ngClass]="item.colorClass" [style.width.%]="item.value"></span>
        </div>
      </div>
    </section>
  </aside>
</div>
